/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCalculationitem } from '../models/work-calculationitem';
import { WorkDocument } from '../models/work-document';
import { WorkItemsForProjectDto } from '../models/work-items-for-project-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkProject } from '../models/work-project';
import { WorkTask } from '../models/work-task';

@Injectable({ providedIn: 'root' })
export class WorkProjectsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `projectsV1ControllerFindAll()` */
  static readonly ProjectsV1ControllerFindAllPath = '/v1/projects';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV1ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerFindAll$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>revenueChf</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'revenueChf:ASC' | 'revenueChf:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProject>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsService.ProjectsV1ControllerFindAllPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkProject>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV1ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerFindAll(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 20
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> id:DESC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>id</li>
     * <li>revenueChf</li></ul>
     */
      sortBy?: Array<'id:ASC' | 'id:DESC' | 'revenueChf:ASC' | 'revenueChf:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> 
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkProject>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}> {
    return this.projectsV1ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkProject>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkProject>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `projectsV1ControllerFindAllPublic()` */
  static readonly ProjectsV1ControllerFindAllPublicPath = '/v1/projects/public';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV1ControllerFindAllPublic()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerFindAllPublic$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<{
}>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsService.ProjectsV1ControllerFindAllPublicPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{
        }>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV1ControllerFindAllPublic$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerFindAllPublic(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<{
}>> {
    return this.projectsV1ControllerFindAllPublic$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
}>>): Array<{
}> => r.body)
    );
  }

  /** Path part for operation `projectsV1ControllerFindOne()` */
  static readonly ProjectsV1ControllerFindOnePath = '/v1/projects/{id}';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV1ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkProject>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsService.ProjectsV1ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkProject>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV1ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkProject> {
    return this.projectsV1ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkProject>): WorkProject => r.body)
    );
  }

  /** Path part for operation `projectsV1ControllerGetItemsForProject()` */
  static readonly ProjectsV1ControllerGetItemsForProjectPath = '/v1/projects/{id}/items';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV1ControllerGetItemsForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetItemsForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkItemsForProjectDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsService.ProjectsV1ControllerGetItemsForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkItemsForProjectDto>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV1ControllerGetItemsForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetItemsForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkItemsForProjectDto> {
    return this.projectsV1ControllerGetItemsForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkItemsForProjectDto>): WorkItemsForProjectDto => r.body)
    );
  }

  /** Path part for operation `projectsV1ControllerGetCalculationitemsForProject()` */
  static readonly ProjectsV1ControllerGetCalculationitemsForProjectPath = '/v1/projects/{id}/calculationitems';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV1ControllerGetCalculationitemsForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetCalculationitemsForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkCalculationitem>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsService.ProjectsV1ControllerGetCalculationitemsForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkCalculationitem>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV1ControllerGetCalculationitemsForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetCalculationitemsForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkCalculationitem>> {
    return this.projectsV1ControllerGetCalculationitemsForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkCalculationitem>>): Array<WorkCalculationitem> => r.body)
    );
  }

  /** Path part for operation `projectsV1ControllerGetTasksForProject()` */
  static readonly ProjectsV1ControllerGetTasksForProjectPath = '/v1/projects/{id}/tasks';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV1ControllerGetTasksForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetTasksForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTask>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsService.ProjectsV1ControllerGetTasksForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTask>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV1ControllerGetTasksForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetTasksForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTask>> {
    return this.projectsV1ControllerGetTasksForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTask>>): Array<WorkTask> => r.body)
    );
  }

  /** Path part for operation `projectsV1ControllerGetBaustellenDispoTasksForProject()` */
  static readonly ProjectsV1ControllerGetBaustellenDispoTasksForProjectPath = '/v1/projects/{id}/tasks/baustellendispo';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV1ControllerGetBaustellenDispoTasksForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetBaustellenDispoTasksForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTask>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsService.ProjectsV1ControllerGetBaustellenDispoTasksForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTask>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV1ControllerGetBaustellenDispoTasksForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetBaustellenDispoTasksForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTask>> {
    return this.projectsV1ControllerGetBaustellenDispoTasksForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTask>>): Array<WorkTask> => r.body)
    );
  }

  /** Path part for operation `projectsV1ControllerGetAppointmentsForProject()` */
  static readonly ProjectsV1ControllerGetAppointmentsForProjectPath = '/v1/projects/{id}/appointments';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV1ControllerGetAppointmentsForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetAppointmentsForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTask>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsService.ProjectsV1ControllerGetAppointmentsForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTask>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV1ControllerGetAppointmentsForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetAppointmentsForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTask>> {
    return this.projectsV1ControllerGetAppointmentsForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTask>>): Array<WorkTask> => r.body)
    );
  }

  /** Path part for operation `projectsV1ControllerGetDocumentsForProject()` */
  static readonly ProjectsV1ControllerGetDocumentsForProjectPath = '/v1/projects/{id}/documents';

  /**
   * Required permissions: projects:read
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `projectsV1ControllerGetDocumentsForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetDocumentsForProject$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkProjectsService.ProjectsV1ControllerGetDocumentsForProjectPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Required permissions: projects:read
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `projectsV1ControllerGetDocumentsForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  projectsV1ControllerGetDocumentsForProject(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.projectsV1ControllerGetDocumentsForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

}
